module.exports = __webpack_public_path__ + "img/dam.b3f9d56c.svg";